import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class ProducerInfoService {
    static getContactSummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('profileinfoProducer'), 'getProducersContactSummaries', [], authHeader);
    }
}
